const Header = ({children}) => {

    return (
        <div className="flex justify-center">
            <div className="hidden md:block grow bg-gradient-to-r from-emerald-50 to-white"></div>
            <div className="relative md:w-[700px] bg-white">
                {children}
            </div>
            <div className="hidden md:block grow bg-gradient-to-l from-emerald-50 to-white"></div>
        </div>
    );
};

export default Header;
